define.alias("shared/utils/analytics/generate-cache-key", "media/utils/analytics/generate-cach-key");